export default {
  or: 'or',
  new: 'NEW',
  beta: 'BETA',
  siteTitle: 'Soundtracks',
  image: {
    alt: 'Loudly logo',
    title: 'Loudly logo',
  },
  topBar: {
    startNow: 'Start Free Now',
    upgrade: 'Upgrade',
    pricing: 'Pricing',
    create: 'Create',
    discoverPlaylists: 'Discover',
    templates: 'Templates',
    releases: 'Releases',
    library: 'Library',
  },
  action: {
    ok: 'Ok',
    done: 'Done',
    cancel: 'Cancel',
    wait: 'Please wait...',
    select: 'Select',
    download: 'Download Track',
    downloadTrackOnly: 'Download Track Only',
    addToLibrary: 'Add to Library',
    close: 'Close',
    upgrade: 'Upgrade',
    copy: 'Copy',
    copyLink: 'Copy Link',
    copied: 'Text copied',
    linkCopied: 'The URL has been copied to your clipboard',
    continue: 'Continue',
    remove: 'Remove',
    loadMore: 'Load More',
  },
  sideBar: {
    title: 'Royalty-free music to unleash your creativity.',
    joinNow: 'Join now',
    links: {
      create: 'Create',
      templates: 'Templates',
      discover: 'Discover',
      pricing: 'Pricing',
      terms: 'Terms of Use',
      license: 'License Agreement',
      privacy: 'Privacy Policy',
      imprint: 'Imprint',
    },
  },
  emailConfirmation: {
    successModal: {
      title: 'Email verified!',
      description: 'We hope you enjoy using our service.',
    },
    verificationModal: {
      title: 'Please verify your email address',
      description: `It looks like you haven’t verified your email address. 

      Please check the email we sent you when you signed up, and click the link. Then you’ll be good to go!`,
    },
    bar: {
      description:
        'You need to verify your account in order to download tracks. Check the email we sent you.',
    },
    action: {
      resend: 'Resend email',
    },
  },
  footer: {
    followSocials: 'Follow us',
    loudly: 'Loudly',
    copyright: '© {{year}} Loudly GmbH Berlin, Germany',
    slogan: 'Loudly Royalty-Free Music',
    legal: 'Legal',
    aboutUs: {
      title: 'About Us',
      about: 'About',
      blog: 'Blog',
      FAQs: 'FAQs',
      contactUs: 'Contact Us',
    },
  },
  error: {
    unknown: 'An unknown error occured. Please contact our support for help.',
  },
  slogan: 'Royalty-free music to unleash your creativity',
  cipher: '€ {{amount}}',
  cipherNA: '$ N/A',
  expiredSessionModal: {
    title: 'Session expired',
    description: 'Please log in to continue',
    actionText: 'Log In',
  },
  dropzone: {
    hint: 'Drag and Drop or <0>Click to Upload</0>',
  },
  copyrightViolationModal: {
    release: {
      title: 'Unable to release track',
      description:
        'This track contains copyrighted material and cannot be released due to legal reasons.',
    },
    pdfLicense: {
      title: 'Unable to generate pdf',
      description:
        'This track contains copyrighted material and cannot be used due to legal reasons.',
    },
    submit: 'Ok, Got it',
  },
};
